import { EmptyDefaultFile, RequestDataAdditionalParams } from '../interfaces'

import { ALL } from './labels'

export const DEFAULT_SEARCH_DEBOUNCE = 300
export const DEFAULT_PAGE_SIZE = 20
export const SEARCH_MIN_LENGTH = 3
export const NO_RESULTS_TEXT = 'No results'
export const TO_FIXED_TWO_DECIMALS = 2
export const EMPTY_FILTER_VALUE = 'EMPTY'
export const EMPTY_AMOUNT = '0.00'
export const DEFAULT_PROCESSING_CENTER_OPTION = 'juarez'
export const GROUP_KEY = 'GROUP_KEY'
export const SERVICE_SITE_ADDRESS_SUFFIX = '(Needs Address)'
export const SINGLE_VALUE_IN_ARRAY = 1

export const POWER_BI_DEFAULT_CODES = ['DEFAULT_ALL']

export const EMPTY_DEFAULT_FILE: EmptyDefaultFile = {
	file: null,
	fileList: []
}
export interface DefaultFile {
	file: File
	fileList: { originFileObj: File }[]
}

export const ALL_OPTION: LabelValue = {
	label: ALL,
	value: ''
}

export const ALL_OPTION_EMPTY_VALUE: LabelValue = {
	label: ALL,
	value: EMPTY_FILTER_VALUE
}

export const NONE_OPTION: LabelValue = {
	label: '<None>',
	value: ''
}

export const EMPTY_LABELVALUE: LabelValue = {
	label: '',
	value: ''
}

export const EMPTY_STORE_VALUE = {
	value: null,
	isLoading: false
}

export const EMPTY_ARRAY_STORE_VALUE = {
	value: [],
	isLoading: false
}

export const inactivityTimeoutSec = 1800

export const BOOLEAN_SELECT_OPTIONS = [
	ALL_OPTION,
	{
		label: 'Yes',
		value: 'true'
	},
	{
		label: 'No',
		value: 'false'
	}
]

export const REPORT_STATUS_OPTIONS: LabelValue[] = [
	ALL_OPTION,
	{
		label: 'Success',
		value: 'Success'
	},
	{
		label: 'Failed',
		value: 'Failed'
	},
	{
		label: 'Running',
		value: 'Running'
	},
	{
		label: 'N/A',
		value: 'NA'
	}
]

export const getReportStatusOptions = (t: TFunction): LabelValue[] => [
	ALL_OPTION,
	{
		label: t('core:labels.success'),
		value: 'Success'
	},
	{
		label: t('core:labels.failed'),
		value: 'Failed'
	},
	{
		label: t('core:labels.running'),
		value: 'Running'
	},
	{
		label: t('core:labels.na'),
		value: 'NA'
	}
]

export const LOAD_DATA: RequestDataAdditionalParams = { loadPage: true, calculateCount: false }
export const LOAD_COUNT: RequestDataAdditionalParams = { loadPage: false, calculateCount: true }
export const SPLITTED_API_ITEMS_TOTAL = -1
